import { c as _c } from "react/compiler-runtime";
import { Button, Popover, Stack, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { pluralize } from '@/utils/string';
export const MIN_WINDOW_HOURS = 4;
const MAX_WINDOW_HOURS = 22;
export const HoursSelector = t0 => {
  const $ = _c(19);
  const {
    hours,
    onChange
  } = t0;
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      padding: "5px 12px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setPopoverOpen(true);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== hours) {
    t3 = pluralize("hour", hours);
    $[2] = hours;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `${hours} ${t3}`;
  let t5;
  if ($[4] !== t4) {
    t5 = <Typography variant="subtitle1Strong">{t4}</Typography>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <i className="material-symbols-arrow-drop-down-rounded text-[22px] ml-[4px]" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <Button sx={t1} ref={setAnchorEl} onClick={t2} data-testid="create-backup-policy-hours-select" disableFocusRipple={true}>{t5}{t6}</Button>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== onChange) {
    t8 = value => {
      setPopoverOpen(false);
      onChange(value);
    };
    $[9] = onChange;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== anchorEl || $[12] !== hours || $[13] !== popoverOpen || $[14] !== t8) {
    t9 = <HoursSelectorPopover anchorEl={anchorEl} hours={hours} onChange={t8} popoverOpen={popoverOpen} />;
    $[11] = anchorEl;
    $[12] = hours;
    $[13] = popoverOpen;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t7 || $[17] !== t9) {
    t10 = <>{t7}{t9}</>;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
const HoursSelectorPopover = t0 => {
  const $ = _c(21);
  const {
    hours,
    onChange,
    anchorEl,
    popoverOpen
  } = t0;
  const [value, setValue] = useState(`${hours}`);
  let t1;
  let t2;
  if ($[0] !== hours) {
    t1 = () => {
      setValue(`${hours}`);
    };
    t2 = [hours];
    $[0] = hours;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== onChange || $[4] !== value) {
    t3 = () => onChange(+value);
    $[3] = onChange;
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      justifyContent: "space-between"
    };
    t5 = <Typography variant="subtitle1" className="mt-[4px] w-[100px]">{`Start time range (${MIN_WINDOW_HOURS}-${MAX_WINDOW_HOURS} hours)`}</Typography>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e => {
      setValue(e.target.value);
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== value) {
    t7 = () => {
      if (+value < MIN_WINDOW_HOURS) {
        setValue(`${MIN_WINDOW_HOURS}`);
      } else {
        if (+value > MAX_WINDOW_HOURS) {
          setValue(`${MAX_WINDOW_HOURS}`);
        }
      }
    };
    $[9] = value;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      htmlInput: {
        min: MIN_WINDOW_HOURS,
        max: MAX_WINDOW_HOURS,
        step: 1,
        pattern: "[0-9]*",
        inputMode: "numeric"
      }
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      width: "80px",
      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "none"
      },
      "& input[type=number]": {
        MozAppearance: "textfield"
      },
      "& .MuiInputBase-root": {
        padding: 0,
        fontSize: "13px"
      },
      "& .MuiOutlinedInput-input": {
        padding: "4px 12px"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: "1px solid var(--mui-palette-primary-main)"
      }
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t7 || $[14] !== value) {
    t10 = <Stack className="p-[24px] w-[308px]" direction="row" sx={t4}>{t5}<TextField value={value} onChange={t6} onBlur={t7} type="number" slotProps={t8} sx={t9} /></Stack>;
    $[13] = t7;
    $[14] = value;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== anchorEl || $[17] !== popoverOpen || $[18] !== t10 || $[19] !== t3) {
    t11 = <Popover disablePortal={true} open={popoverOpen} anchorEl={anchorEl} onClose={t3}>{t10}</Popover>;
    $[16] = anchorEl;
    $[17] = popoverOpen;
    $[18] = t10;
    $[19] = t3;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};